import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function Faq() {

    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "What is Genius Bridge Technologies?",
            answer: "Genius Bridge Technologies is a career platform that helps professionals land jobs through resume optimization, interview training, and direct job placement."
        },
        {
            question: "Is this a free service?",
            answer: "We offer both free resources and premium services like coaching and placement support."
        },
        {
            question: "Do you guarantee job placement?",
            answer: "While we don’t guarantee jobs, we significantly increase your chances with expert guidance and direct referrals."
        },
        {
            question: "How long does the process take?",
            answer: "Most users start seeing results within 2–4 weeks depending on their profile and effort."
        },
        {
            question: "Can beginners apply?",
            answer: "Yes! We help both beginners and experienced professionals grow their careers."
        }
    ];

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // ✅ Smooth scroll with navbar offset
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        const offset = 80;

        if (element) {
            const top = element.offsetTop - offset;
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="relative min-h-screen bg-brand-light pt-32 pb-20 px-6 overflow-hidden">

            {/* BACKGROUND */}
            <div className="absolute inset-0 bg-brand-radial -z-10"></div>

            <div className="max-w-4xl mx-auto">

                {/* HEADER */}
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
                        Frequently Asked{" "}
                        <span className="bg-brand-gradient bg-clip-text text-transparent">
                            Questions
                        </span>
                    </h1>

                    <p className="text-slate-600 text-lg">
                        Everything you need to know about our platform.
                    </p>
                </div>

                {/* FAQ LIST */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl shadow-sm overflow-hidden"
                        >
                            <button
                                onClick={() => toggle(index)}
                                className="w-full flex justify-between items-center px-6 py-5 text-left font-semibold text-slate-900"
                            >
                                {faq.question}

                                <ChevronDown
                                    className={`transition-transform duration-300 ${openIndex === index ? "rotate-180 text-brand-primary" : ""
                                        }`}
                                />
                            </button>

                            {openIndex === index && (
                                <div className="px-6 pb-5 text-slate-600 leading-relaxed">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="mt-16 text-center">
                    <p className="text-slate-600 mb-6">
                        Still have questions?
                    </p>

                    <button onClick={() => scrollToSection('contact')} className="bg-brand-gradient text-white px-10 py-4 rounded-xl font-bold hover:opacity-90 transition-all shadow-lg">
                        Contact Support
                    </button>
                </div>

            </div>
        </div>
    );
}